import React , {Component} from 'react';
import { connect } from "react-redux";
import {receiveProducts} from "../../../actions";
import * as axios from "axios/index";
import * as vars from "../Vars";
import ProductCard from "./ProductCard";
import Loader from "./../loader/ProductCardLoader";

class ProductCategoryV3 extends Component{

    constructor(props){

        super(props)
        this.state = {
            requestLoading : true ,
            page : 1 ,
            products : [] ,
            hasMore : true ,
            currentCategory : null
        }
    }

    componentDidMount(){
        this.setState({
            currentCategory : this.props.currentCategory ,
            branchSlug : this.props.branchSlug ,
        })
        let branchSlug = this.props.branchSlug
        this.props.childLoadMoreHandler()
        axios.get(vars.Url +'api/v3/product/' + branchSlug, {
            params : {
                "api_token" : localStorage.getItem('api_token') ,
                "with-category" : 0 ,
                "with-product" : 1 ,
                "category" : this.props.category.id ,
                "page" : this.state.page
            }

        } )
            .then(response => {
                let data = response.data.data
                //console.log(data)
                this.props.receiveProducts(data.products)
                this.setState({
                    requestLoading : false ,
                    products : [ ...this.state.products , ...data.products] ,
                    hasMore : data.hasMore ,
                    page : this.state.page + 1
                })
                this.props.childLoadMoreHandler()
            })
            .catch(error => {
                // console.log(error)
            })


        document.addEventListener('scroll', this.trackScrolling)
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.currentCategory !== this.props.currentCategory)
        {
            this.setState({
                currentCategory : this.props.currentCategory ,
            })
        }
    }

    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight + 100;
    }
    trackScrolling = () => {
        const wrappedElement = document.getElementById('body');
        if (this.isBottom(wrappedElement)) {
            if (this.state.currentCategory === this.props.category.title)
            {

                if (this.state.hasMore === true && this.state.requestLoading === false)
                {
                    this.setState({
                        requestLoading :true ,
                    })

                    this.props.childLoadMoreHandler()
                    axios.get(vars.Url +'api/v3/product/' + this.state.branchSlug , {
                        params : {
                            "api_token" : localStorage.getItem('api_token') ,
                            "with-category" : 0 ,
                            "with-product" : 1 ,
                            "category" : this.props.category.id ,
                            "page" : this.state.page
                        }

                    } )
                        .then(response => {
                            let data = response.data.data
                            this.props.receiveProducts(data.products)

                            this.setState({
                                requestLoading : false ,
                                products : [ ...this.state.products , ...data.products] ,
                                hasMore : data.hasMore ,
                                page : this.state.page + 1
                            })
                            this.props.childLoadMoreHandler()
                        })
                        .catch(error => {
                            // console.log(error)
                        })
                }
            }
        }
    }

    componentWillUnmount(){
        document.removeEventListener('scroll', this.trackScrolling)
    }


    render(){
        const {products , currentTime , needPreOrder , cartHandler } = this.props
        return(
            <div className="product-card">

                {this.state.products.map((object , index) =>
                    <ProductCard
                        key={index}
                        product={products[object.id]}
                        currentTime={currentTime}
                        needPreOrder={() => needPreOrder() }
                        cartHandler={cartHandler}
                    />
                )}

                {this.state.requestLoading === true ? (
                    <Loader />
                ) : (
                    ``
                )}

            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({
    receiveProducts : products => dispatch(receiveProducts(products)) ,
})

const mapStateToProps = state => {
    return {
        products : state.products ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(ProductCategoryV3);